import { Option } from "../interfaces/form-fields";

export enum Currency {
  NGN = 1,
  USD = 2,
  GBP = 3,
  EUR = 4,
  ZAR = 5,
  GHS = 6,
  XAF = 7
}

export const getCurrencyLabel = (type: Currency, format?: 'full' | 'symbol'): string => {
  const currencyMap: Record<Currency, { name?: string; code: string; symbol: string }> = {
    [Currency.NGN]: { name: 'Nigerian Naira', code: 'NGN', symbol: '₦' },
    [Currency.USD]: { name: 'US Dollar', code: 'USD', symbol: '$' },
    [Currency.GBP]: { name: 'British Pound', code: 'GBP', symbol: '£' },
    [Currency.EUR]: { name: 'Euro', code: 'EUR', symbol: '€' },
    [Currency.ZAR]: { name: 'South African Rand', code: 'ZAR', symbol: 'R' },
    [Currency.GHS]: { name: 'Ghanaian Cedi', code: 'GHS', symbol: '₵' },
    [Currency.XAF]: { name: 'Central African CFA Franc', code: 'XAF', symbol: '₣' } // Fr
  };

  const currency = currencyMap[type];
  if (!currency) return '';

  return format === 'symbol'
    ? currency.symbol
    : `${currency.code} (${currency.symbol})`;
};

export const CURRENCIES: Option[] = [
  Currency.NGN,
  Currency.USD,
  Currency.GBP,
  Currency.EUR,
  Currency.ZAR,
  Currency.GHS,
  Currency.XAF
].map(c => ({ label: getCurrencyLabel(c), value: c }));